var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-wapper"},[_c('header',[_c('div',{staticClass:"head-logo"},[_c('img',{attrs:{"src":_vm.logo}})]),_c('div',{staticClass:"login"},[_c('router-link',{attrs:{"to":"/tob/login"}},[_vm._v("登录")]),_c('router-link',{attrs:{"to":"/main"}},[_vm._v("控制台")]),_c('router-link',{attrs:{"to":"/train/index"}},[_vm._v("培训")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }